
export default function BlogSingleArea({ data }) {


 var today = new Date(data.date)

  return (
     <div>

            <div className="blog-post">
              <div className="blog-details-content">
                
                <div className="text-holder">
                  <ul className="meta-info">
                    <li><a href="#"  aria-label="some more descriptive text that explains the link">{today.toLocaleDateString('en-GB', {
                                        day : 'numeric',
                                        month : 'short',
                                        year : 'numeric'
                                    }).split(' ').join('-') } </a></li>
                                         </ul>
                  <h2 className="blog-title">{data.title?.rendered}</h2>
                  <div className="text">
                    <p className="" dangerouslySetInnerHTML={{__html: data.content?.rendered}}></p>
                  </div>
                </div>
               
                
              </div>
              
             
            
            </div>
              
      </div>
  );
}